<template>
  <div class="home">
    <v-container fluid>
      <TopSlide v-if="$vuetify.breakpoint.lgAndUp"/>
      <Module v-else/>
      <div class="mt-6">
        <ProductRecent/>
      </div>
      <div class="mt-6">
        <v-container fluid>
          <v-row>
            <v-col cols="12" md="9">
              <Market/>
            </v-col>
            <v-col cols="12" md="3">
              <Environment/>
            </v-col>
          </v-row>
        </v-container>
      </div>
      <div class="mt-6">
        <News/>
      </div>
      <div class="mt-6">
        <WebLink/>
      </div>
    </v-container>
  </div>
</template>
<script>
import TopSlide from '@/components/public/home/TopSlide';
import Module from '@/components/public/home/Module';
import ProductRecent from '@/components/public/home/ProductRecent';
import Market from '@/components/public/home/Market';
import Environment from '@/components/public/home/Environment';
import News from '@/components/public/home/News';
import WebLink from '@/components/public/home/WebLink';
import { mapActions } from 'vuex';
export default {
  name: 'Home',
  components: {
    TopSlide,
    Module,
    ProductRecent,
    Market,
    Environment,
    News,
    WebLink
  },
  mounted () {
    this.toggleHeaderSlider(true);
  },
  methods: {
    ...mapActions([
      'toggleHeaderSlider'
    ]),
  }
}
</script>